export const MARK_COMPLETED = 'features/Checklist/MARK_COMPLETED';
export const UNDO_COMPLETED = 'features/Checklist/UNDO_COMPLETED';
export const RECEIVED_CHECKLISTS = 'features/Checklist/RECEIVED_CHECKLISTS';
